import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ValuablesProduct } from "Store/interfaces/products/checkout/riskProducts/ValuablesProduct";
import React from "react";
import { ProductDetail } from "../../interface";

const getValuableInfo = (
  product: ValuablesProduct,
  types: any,
  lang: string,
): string => {
  if (product.model) {
    return `${product.model}`;
  }

  if (product.brand) {
    return `${product.brand}`;
  }

  return types[product.valuableType][lang];
};

export const valuablesDetailsList = (
  product: ValuablesProduct,
  types: any,
  lang: string,
  urls: Record<string, string>,
): ProductDetail[] => {
  const hideRecentDamageYear = product.damageCountRecentYears === 0;
  const { applicableTermsValuables } = urls;

  const description = {
    name: "description",
    value: product.description,
    suppressHJ: true,
  };

  return [
    {
      name: "valuable",
      value: getValuableInfo(product, types, lang),
    },
    {
      name: "productionYear",
      value: product.yearOfManufacture,
    },
    ...(product.description ? [description] : []),
    {
      name: "damageRecentYears",
      value: product.damageCountRecentYears,
    },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: hideRecentDamageYear,
    },
    {
      name: "deductible",
      value: (
        <a href={applicableTermsValuables} target="_blank" rel="noreferrer">
          {<DeductibleValue value={"??"} />}
        </a>
      ),
    },
  ];
};
